 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML02_COPYRIGHT from '@/components/html/02_Copyright'
 import HTML01_TITLE_PAGE from '@/components/html/01_Title_Page'
 import HTML03_DEDICATION from '@/components/html/03_Dedication'
 import HTML04_CONTENTS from '@/components/html/04_CONTENTS'
 import HTML05_PREFACE from '@/components/html/05_Preface'
 import HTML06_ACKNOWLEDGMENTS from '@/components/html/06_Acknowledgments'
 import HTML07_INTRODUCTION___US_LAW_AND_RELIGI from '@/components/html/07_INTRODUCTION___US_Law_and_Religi'
 import HTML08_ONE___SPIRITUAL_GOVERNANCE from '@/components/html/08_ONE___Spiritual_Governance'
 import HTML09_TWO___THE_CHAPLAIN from '@/components/html/09_TWO___The_Chaplain'
 import HTML10_THREE___CREDENTIALING_CHAPLAINS from '@/components/html/10_THREE___Credentialing_Chaplains'
 import HTML11_FOUR___CHAPLAINS_AND_THE_CONSTIT from '@/components/html/11_FOUR___Chaplains_and_the_Constit'
 import HTML12_FIVE___A_MINISTRY_OF_PRESENCE from '@/components/html/12_FIVE___A_Ministry_of_Presence'
 import HTML13_AFTERWORD from '@/components/html/13_Afterword'
 import HTML14_APPENDIX__ARMED_FORCES_CHAPLAINS from '@/components/html/14_Appendix__Armed_Forces_Chaplains'
 import HTML15_NOTES from '@/components/html/15_Notes'
 import HTML15_SELECTED_BIBLIOGRAPHY from '@/components/html/15_Selected_Bibliography'
 import HTML16_INDEX from '@/components/html/16_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/04_CONTENTS",
 			"name" : "html/04_CONTENTS",
 			"component" : HTML04_CONTENTS
 		},
 		{
 			"path" : "/html/05_Preface",
 			"name" : "html/05_Preface",
 			"component" : HTML05_PREFACE
 		},
 		{
 			"path" : "/html/06_Acknowledgments",
 			"name" : "html/06_Acknowledgments",
 			"component" : HTML06_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/html/07_INTRODUCTION___US_Law_and_Religi",
 			"name" : "html/07_INTRODUCTION___US_Law_and_Religi",
 			"component" : HTML07_INTRODUCTION___US_LAW_AND_RELIGI
 		},
 		{
 			"path" : "/html/08_ONE___Spiritual_Governance",
 			"name" : "html/08_ONE___Spiritual_Governance",
 			"component" : HTML08_ONE___SPIRITUAL_GOVERNANCE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js